import { ComponentType, createContext } from 'react';

type Page = {
  component: ComponentType;
};

export enum SearchStyle {
  dropdown = 'dropdown',
  resultsPage = 'resultsPage',
}

export type Config = {
  pages: {
    home: Page;
    article: Page;
    category: Page;
    search?: Page;
    error: Page;
    error401?: Page;
    error404: Page;
  };
  searchStyle?: SearchStyle;
  hideLoadingProgress?: boolean;
  forceRefreshRouting?: boolean;
  pageLoadingIndicator: ComponentType;
  extraPages?: Array<{
    path: string;
    component: ComponentType;
    getTitle: () => string;
  }>;
};
// The default {} will never be used as we wrap the App component with this.
export const Context = createContext<Config>({} as any);
